module.exports = __webpack_public_path__ + "static/img/5960_phase_function_Paper_Points.56a52e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5960_phase_function_Paper_Points.png
// module id = H50/
// module chunks = 0